
import moment from 'moment';

export default{

    dateToCurrentTimeZone(dateString){
        return new Date(moment.utc(dateString).local());
    },
    dateToUTC(date){
        return moment.utc(date).valueOf();
    },
    formatDate(date){
        return moment(date).format('DD/MM/yy');
    },
    formatDateMonth(date){
        return moment(date).format('DD/MM');
    },
    formatMonthYear(date){
        return moment(date).format('MM/yy');
    },
    formatMonthYearLocale(date){
        return moment(date).format('MMMM yyyy');
    },
    formatMonthYearExtended(date){
        return moment(date).format('MMM_yyyy');
    },
    formatDateTime(date, format='DD/MM/yy HH:mm'){
        return date != null ? moment(date).format(format) : '';
    },
    formatDate(date, format='DD/MM/yyyy'){
        return date != null ? moment(date).format(format) : '';
    },
    formatDateForAPI(date){
        return moment(date).format('yy-MM-DD');
    },
    formatDateForAPIWithTime(date){
        return moment.utc(date).format('yy-MM-DD HH:mm:ss');
    },
    formatDatePlusDays(date, days){
        let newDate = new Date(date.getTime());
        newDate.setHours(0,0,0,0);
        newDate.setDate(newDate.getDate() + days);
        return newDate;
    },
    formatDatePlusDaysSameTime(date, days){
        let newDate = new Date();
        newDate.setDate(newDate.getDate() + days);
        
        newDate.setHours(date.getHours(),date.getMinutes(),0,0);
        return newDate;
    },
    formatDatePlusMonths(date, months){
        let newDate = new Date(date.getTime());
        newDate.setHours(0,0,0,0);
        newDate.setMonth(newDate.getMonth() + months);
        return newDate;
    },
    setDay(date, dayNumber){
        let newDate = new Date(date.getTime());
        newDate.setDate(dayNumber);
        return newDate;
    },
    formatEndDate(date){
        let newDate = new Date(date.getTime());
        newDate.setDate(newDate.getDate() + 1);
        newDate.setSeconds(newDate.getSeconds() -1);
        return newDate;
    },
    setLastDayOfMonth(date){
        let newDate = new Date(date.getTime());
        newDate.setHours(0,0,0,0);
        newDate.setDate(1);
        newDate.setMonth(newDate.getMonth() + 1);
        newDate.setDate(newDate.getDate() - 1);
        return newDate;
    },
    setFirstDayOfMonth(date){
        let newDate = new Date(date.getTime());
        newDate.setHours(0,0,0,0);
        newDate.setDate(1);
        newDate.setMonth(newDate.getMonth() + 1);
        return newDate;
    },
    dateEquals(d1, d2){
        if(d1 != null && d2 != null){
            return d1.getTime() == d2.getTime()
        }else if(d1 == null && d2 == null){
            return true;
        }
        return false;
    },
    formatDecimal(n, digits){
        if(!digits){
            digits = 2;
        }
        return n ? n.toLocaleString(undefined, {minimumFractionDigits: digits, maximumFractionDigits: digits}) : null;
        
    },
    formatDecimal(n, digits, options){
        if(!digits){
            digits = 2;
        }

        if(!options){
            options = undefined;
        }

        return n ? n.toLocaleString(options, {minimumFractionDigits: digits, maximumFractionDigits: digits}) : null;       
    },
    formatInteger(n){
        if(n || n == 0){
            return n.toLocaleString();
        }
        return null;
    },
    isToday(d){
        return this.formatDateForAPI(d) == this.formatDateForAPI(new Date())
    },

    nullSAndMS(date){
        date.setSeconds(0);
        date.setMilliseconds(0);
    },
    formatDateWithFormat(date, format){
        return moment(date).format(format);
    }
}